class ProductQuantity extends HTMLElement {
  constructor() {
    super();
    this.rangeInput = null;
    this.numberInput = null;
    this.minQuantity = 1;
  }

  connectedCallback() {
    this.rangeInput = this.querySelector('.main-product__quantity-range input[type="range"]');
    this.numberInput = this.querySelector('.main-product__quantity-number');

    this.minQuantity = parseInt(this.dataset.minQuantity) || 1;

    if (this.rangeInput && this.numberInput) {
      this.setupEventListeners();
      this.syncInitialValues();
    }
  }

  setupEventListeners() {
    this.rangeInput.addEventListener('input', () => {
      this.numberInput.value = this.rangeInput.value;
      this.dispatchQuantityChangeEvent();
    });

    this.numberInput.addEventListener('input', () => {
      this.handleNumberInputChange();
    });

    this.numberInput.addEventListener('blur', () => {
      const value = parseInt(this.numberInput.value);

      if (this.numberInput.value === '' || isNaN(value) || value < this.minQuantity) {
        this.numberInput.value = this.minQuantity;
        this.rangeInput.value = this.minQuantity;
        this.dispatchQuantityChangeEvent();
      } else {
        const max = parseInt(this.numberInput.max);
        if (!isNaN(max) && value > max) {
          this.numberInput.value = max;
          this.rangeInput.value = max;
          this.dispatchQuantityChangeEvent();
        }
      }
    });

    this.addEventListener('variant:change', this.handleVariantChange.bind(this));
  }

  handleNumberInputChange() {
    const value = parseInt(this.numberInput.value);
    const min = parseInt(this.numberInput.min);
    const max = parseInt(this.numberInput.max);

    if (isNaN(value) || this.numberInput.value === '') {
      return;
    }

    if (value >= min) {
      if (isNaN(max) || value <= max) {
        this.rangeInput.value = value;
        this.dispatchQuantityChangeEvent();
      } else {
        this.numberInput.value = max;
        this.rangeInput.value = max;
        this.dispatchQuantityChangeEvent();
      }
    }
  }

  syncInitialValues() {
    if (this.rangeInput.value !== this.numberInput.value) {
      this.rangeInput.value = this.numberInput.value;
    }
  }

  handleVariantChange(event) {
    const { variant } = event.detail;
    if (variant) {
      this.updateMaxQuantity(variant.inventory_quantity, variant.inventory_management);
    }
  }

  updateMaxQuantity(inventoryQuantity, inventoryManagement) {
    if (inventoryManagement === null || inventoryManagement === undefined) {
      this.rangeInput.removeAttribute('max');
      this.numberInput.removeAttribute('max');

      this.rangeInput.max = 99;
      return;
    }

    let maxQuantity = inventoryQuantity;

    if (maxQuantity <= 0) {
      maxQuantity = this.minQuantity;
    }

    this.rangeInput.max = maxQuantity;
    this.numberInput.max = maxQuantity;

    const currentValue = parseInt(this.numberInput.value);
    if (currentValue > maxQuantity) {
      this.numberInput.value = maxQuantity;
      this.rangeInput.value = maxQuantity;
      this.dispatchQuantityChangeEvent();
    }
  }

  dispatchQuantityChangeEvent() {
    let quantity = parseInt(this.numberInput.value);

    if (isNaN(quantity) || quantity < this.minQuantity) {
      quantity = this.minQuantity;
      this.numberInput.value = quantity;
      this.rangeInput.value = quantity;
    }

    document.dispatchEvent(new CustomEvent('quantity-changed', {
      detail: { quantity },
      bubbles: true
    }));
  }

  getValue() {
    return parseInt(this.numberInput.value);
  }

  setValue(value) {
    const min = this.minQuantity;
    const max = parseInt(this.numberInput.max);

    if (isNaN(max)) {
      value = Math.max(min, value);
    } else {
      value = Math.max(min, Math.min(max, value));
    }

    this.numberInput.value = value;
    this.rangeInput.value = value;
    this.dispatchQuantityChangeEvent();
  }

  getMinQuantity() {
    return this.minQuantity;
  }

  getMaxQuantity() {
    const max = parseInt(this.numberInput.max);
    return isNaN(max) ? null : max;
  }
}

customElements.define('product-quantity', ProductQuantity);
